import { RslReport } from '@features/campaigns/subdomains/rsl';
import {
  SalesOptimizationChartOptions,
  salesOptimizationChart,
} from '@features/executive-report/configuration/sales-optimization-chart';
import { chartOptionsToBase64Svg } from '@features/powerpoint';
import { SECTION_X_OFFSET } from './layout';
import { SalesOptimizationSummaryOptions } from '../sales-optimization-summary';

const PPT_CHART_WIDTH = 5.84;
const PPT_CHART_HEIGHT = 3.55;
const PTT_CHART_SCALING_FACTOR = 100;
const PX_CHART_WIDTH = PPT_CHART_WIDTH * PTT_CHART_SCALING_FACTOR;
const PX_CHART_HEIGHT = PPT_CHART_HEIGHT * PTT_CHART_SCALING_FACTOR;

const reportToChartData = (
  report: RslReport
): SalesOptimizationChartOptions['data'] => [
  {
    sales: report.penetration ?? 0,
    lift: report.penetrationLift ?? 0,
    label: 'Penetration',
  },
  {
    sales: report.transactionRate ?? 0,
    lift: report.transactionRateLift ?? 0,
    label: 'Transaction Rate',
  },
  {
    sales: report.transactionSize ?? 0,
    lift: report.transactionSizeLift ?? 0,
    label: 'Transaction Size',
  },
];

export const images = (options: SalesOptimizationSummaryOptions) => {
  return [
    ...(options.midCampaignReport
      ? [
          {
            data: chartOptionsToBase64Svg({
              chartOptions: salesOptimizationChart({
                data: reportToChartData(options.midCampaignReport),
              }),
              width: PX_CHART_WIDTH,
              height: PX_CHART_HEIGHT,
            }),
            h: PPT_CHART_HEIGHT,
            w: PPT_CHART_WIDTH,
            x: 0.82,
            y: 3.38,
          },
        ]
      : []),
    {
      data: chartOptionsToBase64Svg({
        chartOptions: salesOptimizationChart({
          data: reportToChartData(options.currentReport),
        }),
        width: PX_CHART_WIDTH,
        height: PX_CHART_HEIGHT,
      }),
      h: PPT_CHART_HEIGHT,
      w: PPT_CHART_WIDTH,
      x: 0.82 + SECTION_X_OFFSET,
      y: 3.38,
    },
  ];
};
